$(document).ready(function() {
  const validationSchema = new AdvertisementValidationSchema();
  const validationHelper = new ValidationHelper(validationSchema);
  const formHandler = new FormHandler('form[data-turbo="false"][action*="advertisement_campaigns"]', validationHelper);

  // ===== CITY SELECTION PRESERVATION =====
  function preserveCitySelect() {
    const citySelect = $('#pet-city-select');
    const prefectureSelect = $('#pet-prefecture-select');
    
    if (citySelect.length && prefectureSelect.length) {
      const cityValue = citySelect.data('city');
      const prefectureValue = prefectureSelect.val();
      
      if (cityValue && prefectureValue) {
        const checkOptions = () => {
          const options = citySelect.find('option');
          if (options.length > 1) {
            citySelect.val(cityValue);
          } else {
            setTimeout(checkOptions, 100);
          }
        };
        checkOptions();
      }
    }
  }

  // ===== BANNER CLICK TRACKING =====
  $('.banner-pc a, .banner-sp a').on('click', function(event) {
    var url = $(this).attr('href');
    var advertisementCampaignId = $(this).data('advertisement_campaign_id');
    event.preventDefault();

    $.ajax({
      url: '/clicks',
      method: 'POST',
      data: {
        advertisement_campaign_id: advertisementCampaignId,
        _token: $('meta[name="csrf-token"]').attr('content')
      },
      success: function() {
        window.open(url, '_blank');
      },
      error: function() {
        window.open(url, '_blank');
      }
    });
  });

  // ===== OWNER TYPE TOGGLE =====
  var companyOption = document.getElementById('owner_type_company');
  var individualOption = document.getElementById('owner_type_individual');
  var nameLabel = document.getElementById('name_label');
  var individualContainer = document.getElementById('individual_name_container');
  var companyContainer = document.getElementById('company_name_container');

  function updateNameField() {
    if (companyOption && companyOption.checked) {
      if (nameLabel) nameLabel.textContent = '会社名';
      if (individualContainer) individualContainer.style.display = 'none';
      if (companyContainer) companyContainer.style.display = 'block';
    } else if (individualOption && individualOption.checked) {
      if (nameLabel) nameLabel.textContent = '個人名';
      if (individualContainer) individualContainer.style.display = 'block';
      if (companyContainer) companyContainer.style.display = 'none';
    }
  }

  if (companyOption) companyOption.addEventListener('change', updateNameField);
  if (individualOption) individualOption.addEventListener('change', updateNameField);
  updateNameField();

  // ===== IMAGE PREVIEW HANDLING =====
  function handleBannerPreview(inputSelector, previewSelector, aspectRatio, maxWidth) {
    $(inputSelector).off('change').on('change', function(e) {
      
      const file = this.files[0];
      if (file) {
        const maxSize = 10 * 1024 * 1024; // 10MB in bytes

        if (file.size > maxSize) {
          $('body').append(`
          <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
                    画像は10MBサイズ以下でアップお願いします。
                  </div>
                </div>
              </div>
            </div>
          </div>
        `)
          $('#image_modal').show();
          $('#image_modal').addClass('show')
          $(document).on('click', '#image_modal button', function () {
            $('#image_modal').remove();
          })
          $(inputSelector)[0].value = '';
          return;
        }

        if(inputSelector == '#banner_pc_image') {
          $('input[name="advertisement_campaign[existing_pc_image]"]').val('true');
        } else if(inputSelector == '#banner_mobile_image') {
          $('input[name="advertisement_campaign[existing_mobile_image]"]').val('true');
        }

        const reader = new FileReader();

        reader.onload = function(readerEvent) {
          const img = new Image();
          img.onload = function(e) {
            if(inputSelector == '#banner_pc_image' && (this.width != 300 || this.height != 250)) {
              $('body').append(`
                <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
                          PC用バナー画像は300x250pxでアップお願いします。
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `)
              $('#image_modal').show();
              $('#image_modal').addClass('show')
              $(document).on('click', '#image_modal button', function () {
                $('#image_modal').remove();
              })
              $(inputSelector)[0].value = '';
              $(previewSelector).html(`
                <div class="banner-placeholder pc-banner">
                  <span>300x250px</span>
                </div>
              `);
              $('input[name="advertisement_campaign[existing_pc_image]"]').val('false');
              return;
            } else if (inputSelector == '#banner_mobile_image' && (this.width != 320 || this.height != 50)) {
              $('body').append(`
                <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      </div>
                      <div class="modal-body">
                        <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
                          モバイル用バナー画像は320x50pxでアップお願いします。
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `)
              $('#image_modal').show();
              $('#image_modal').addClass('show')
              $(document).on('click', '#image_modal button', function () {
                $('#image_modal').remove();
              })
              $(inputSelector)[0].value = '';
              $(previewSelector).html(`
                <div class="banner-placeholder mobile-banner">
                  <span>320x50px</span>
                </div>
              `);
              $('input[name="advertisement_campaign[existing_mobile_image]"]').val('false');
              return;
            } else {
              $(previewSelector).html(`
                <div class="ratio" style="--bs-aspect-ratio: ${aspectRatio}%; max-width: ${maxWidth}px">
                  <img src="${readerEvent.target.result}" alt="Preview" class="w-100 h-100" style="object-fit: cover; object-position: center; border-radius: 8px;" />
                </div>
              `);
            }
          };
          img.src = readerEvent.target.result;

        };
        reader.readAsDataURL(file);
      }
    });
  }

  function initializeBannerPreview() {
    handleBannerPreview('#banner_pc_image', '.advertisements-banner_pc-image-preview', 83.333, 300);
    handleBannerPreview('#banner_mobile_image', '.advertisements-banner_sp-image-preview', 15.625, 320);
  }

  // ===== PREVIEW MODE TOGGLE =====
  const PREVIEW_SELECTORS = {
    form: '.form-validate',
    preview: '.preview-advertisement',
    titleCreate: '.title-create',
    titlePreview: '.title-preview'
  };

  function initializeAdvertisementPreview() {
    $(document).on('click', '.btn-submit-advertisement', handlePreviewToggle);
    $(document).on('click', '.btn-back-advertisement', handleEditToggle);
  }

  function handlePreviewToggle(e) {
    e.preventDefault();
    
    const form = $(this).closest('form');
    if (form.length === 0) return;
    
    validationHelper.clearAllErrors();
    if (!validationHelper.validateForm(form)) return;
    
    switchToPreviewMode();
    populatePreviewContent();
  }

  function handleEditToggle(e) {
    e.preventDefault();
    switchToEditMode();
  }

  function switchToPreviewMode() {
    toggleMode(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function switchToEditMode() {
    toggleMode(false);
  }

  function toggleMode(isPreview) {
    const { form, preview, titleCreate, titlePreview } = PREVIEW_SELECTORS;
    
    $(form).toggleClass('d-none', isPreview);
    $(preview).toggleClass('d-none', !isPreview);
    $(titleCreate).toggleClass('d-none', isPreview);
    $(titlePreview).toggleClass('d-none', !isPreview);
  }

  // ===== PREVIEW CONTENT POPULATION =====
  function populatePreviewContent() {
    const previewData = getPreviewData();
    updatePreviewElements(previewData);
    updateBannerPreviews();
  }

  function getPreviewData() {
    const ownerType = $('input[name="advertisement_campaign[owner_type]"]:checked').val();
    
    return {
      ownerType,
      companyName: $('#company_name').val() || '',
      individualName: $('#individual_name').val() || '',
      address: [
        $('#pet-prefecture-select option:selected').text(),
        $('#pet-city-select option:selected').text(),
        $('#advertisement_campaign_address').val()
      ].filter(Boolean).join(''),
      contact: {
        personName: $('#contact_person_name').val() || '',
        email: $('#contact_email').val() || '',
        phone: $('#contact_phone').val() || ''
      },
      link: $('#link').val() || '',
      content: $('#content').val() || '',
      placementPositions: getSelectedPositionLabels(),
      duration: $('#duration_months option:selected').text()
    };
  }

  function updatePreviewElements(data) {
    $('.preview-owner-type').text(data.ownerType === 'company' ? '会社' : '個人');
    
    const isCompany = data.ownerType === 'company';
    $('.preview-company-name').toggle(isCompany);
    $('.preview-individual-name').toggle(!isCompany);
    $('.preview-company-name-value').text(data.companyName);
    $('.preview-individual-name-value').text(data.individualName);
    
    $('.preview-address').text(data.address);
    
    $('.preview-contact-person-name').text(data.contact.personName);
    $('.preview-contact-email').text(data.contact.email);
    $('.preview-contact-phone').text(data.contact.phone);
    
    $('.preview-link').html(data.link ? 
      `<a href="${data.link}" target="_blank" class="text-dark">${data.link}</a>` : ''
    );
    
    $('.preview-content').css('white-space', 'pre-wrap').text(data.content);
    
    $('.preview-placement-positions').text(
      data.placementPositions.length > 0 ? 
      data.placementPositions.join(', ') : 
      '選択されていません'
    );
    
    $('.preview-duration-months').text( 
      data.duration && data.duration !== '選択してください' ? 
      data.duration : 
      '選択されていません'
    );
  }

  function updateBannerPreviews() {
    updateBannerPreview();
    updateMobileBannerPreview();
  }

  const bannerTemplate = (src, aspectRatio, maxWidth, placeholder) => 
    src ? `
      <div class="ratio" style="--bs-aspect-ratio: ${aspectRatio}%; max-width: ${maxWidth}px">
        <img src="${src}" class="w-100 h-100 object-fit-cover" style="border-radius: 8px;" />
      </div>
    ` : `<div class="banner-placeholder ${placeholder}"><span>${maxWidth}x${Math.round(maxWidth * aspectRatio / 100)}px</span></div>`;

  function updateBannerPreview() {
    const pcImageFile = $('#banner_pc_image')[0].files[0];
    const existingImage = $('.advertisements-banner_pc-image-preview img').attr('src');
    const existingPcImage = $('input[name="advertisement_campaign[existing_pc_image]"]').val() === 'true';
    
    if (pcImageFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        $('.preview-banner-pc').html(bannerTemplate(e.target.result, 83.333, 300, 'pc-banner'));
      };
      reader.readAsDataURL(pcImageFile);
    } else if (existingImage && existingPcImage) {
      $('.preview-banner-pc').html(bannerTemplate(existingImage, 83.333, 300, 'pc-banner'));
    } else {
      $('.preview-banner-pc').html(bannerTemplate(null, 83.333, 300, 'pc-banner'));
    }
  }

  function updateMobileBannerPreview() {
    const mobileImageFile = $('#banner_mobile_image')[0].files[0];
    const existingImage = $('.advertisements-banner_sp-image-preview img').attr('src');
    const existingMobileImage = $('input[name="advertisement_campaign[existing_mobile_image]"]').val() === 'true';
    
    if (mobileImageFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        $('.preview-banner-mobile').html(bannerTemplate(e.target.result, 15.625, 320, 'mobile-banner'));
      };
      reader.readAsDataURL(mobileImageFile);
    } else if (existingImage && existingMobileImage) {
      $('.preview-banner-mobile').html(bannerTemplate(existingImage, 15.625, 320, 'mobile-banner'));
    } else {
      $('.preview-banner-mobile').html(bannerTemplate(null, 15.625, 320, 'mobile-banner'));
    }
  }

  // ===== PRICING CALCULATION =====
  function initializePricing() {
    updatePricingSummary();
  }

  function getSelectedPositions() {
    const positions = [];
    $('input[name="advertisement_campaign[placement_position][]"]:checked').each(function() {
      positions.push(parseInt($(this).val()));
    });
    return positions;
  }

  function getSelectedPositionLabels() {
    const labels = [];
    $('input[name="advertisement_campaign[placement_position][]"]:checked').each(function() {
      labels.push($(this).next('label').text());
    });
    return labels;
  }

  function updatePricingSummary() {
    const selectedLabels = getSelectedPositionLabels();
    $('#selected-positions').text(selectedLabels.length > 0 ? selectedLabels.join(', ') : '選択してください');

    const durationText = $('#duration_months option:selected').text();
    $('#selected-duration').text(durationText && durationText !== '選択してください' ? durationText : '選択してください');

    calculateTotalPrice();
  }

  function calculateTotalPrice() {
    const selectedPositions = getSelectedPositions();
    const duration = $('#duration_months').val();
    
    if (selectedPositions.length > 0 && duration) {
      $.ajax({
        url: '/user/advertisement_campaigns/calculate_price',
        type: 'POST',
        data: {
          placement_positions: selectedPositions,
          duration_months: duration,
          authenticity_token: $('meta[name="csrf-token"]').attr('content')
        },
        success: function(response) {
          $('#total-price').text(response.display_price);
          updatePricingBreakdown(response);
        },
        error: function(xhr) {
          console.error('Error calculating price:', xhr);
          $('#total-price').text('0');
          $('#pricing-breakdown').text('料金の取得に失敗しました。時間をおいて再度お試しください。');
        }
      });
    } else {
      $('#total-price').text('0');
      $('#pricing-breakdown').text('掲載位置と期間を選ぶと内訳が表示されます。');
    }
  }

  function updatePricingBreakdown(response) {
    const selectedPositions = response.selected_positions || [];
    const positionRows = selectedPositions.map(function(position) {
      return `<div class="pricing-breakdown-row"><span>${position.label}</span><strong>${position.display_monthly_price}円/月</strong></div>`;
    }).join('');
    const discountRow = response.discount_percentage > 0
      ? `<div class="pricing-breakdown-row discount"><span>期間割引 ${response.discount_percentage}%</span><strong>-${response.display_discount_amount}円</strong></div>`
      : '';

	  $('#pricing-breakdown').html(`
	    <div class="pricing-breakdown-title">料金内訳</div>
	    ${positionRows}
	    <div class="pricing-breakdown-row subtotal"><span>月額小計</span><strong>${response.display_monthly_price}円/月</strong></div>
	    <div class="pricing-breakdown-row"><span>掲載期間</span><strong>${response.duration_months}ヶ月</strong></div>
	    <div class="pricing-breakdown-row"><span>割引前合計</span><strong>${response.display_base_price}円</strong></div>
	    ${discountRow}
	  `);
	}

  // ===== CARD CLICK HANDLING =====
  function initializeCardClicks() {
    $('.advertisement-campaign-card').off('click.cardClick').on('click.cardClick', function(e) {
      if ($(e.target).closest('.btn, button').length > 0) {
        return;
      }
      
      const campaignId = $(this).data('campaign-id');
      const link = $(this).data('link');
      
      if (link) {
        if (campaignId) {
          $.ajax({
            url: '/clicks',
            method: 'POST',
            data: {
              advertisement_campaign_id: campaignId,
              _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function() {
              window.open(link, '_blank');
            },
            error: function() {
              window.open(link, '_blank');
            }
          });
        } else {
          window.open(link, '_blank');
        }
      }
    });
  } 

  // ===== BOOTSTRAP CAROUSEL SUPPORT (PC ONLY) =====
  function initializeBootstrapCarousel() {
    document.querySelectorAll('.carousel').forEach(carouselElement => {
      carouselElement.addEventListener('mouseenter', function() {
        const carousel = bootstrap.Carousel.getInstance(this) || new bootstrap.Carousel(this);
        carousel.pause();
      });
      
      carouselElement.addEventListener('mouseleave', function() {
        const carousel = bootstrap.Carousel.getInstance(this) || new bootstrap.Carousel(this);
        carousel.cycle();
      });
    });
  }

  // ===== HEADER ADVERTISEMENTS CAROUSEL INITIALIZATION =====
  $(document).on('turbolinks:load turbo:load', function() {
    document.querySelectorAll('.carousel').forEach(carouselElement => {
      const carousel = bootstrap.Carousel.getInstance(carouselElement) || new bootstrap.Carousel(carouselElement);
      carousel.cycle();
    });
  });

  // ===== PC FOOTER ADVERTISEMENTS ROTATION =====
  function initializeFooterAdvertisements() {
    const footerAds = window.footerAdvertisements || [];
    if (footerAds.length === 0) return { stop: () => {} };
    
    if (window.footerRotationInterval) {
      clearInterval(window.footerRotationInterval);
      window.footerRotationInterval = null;
    }
    
    let currentIndex = 0;
    let rotationInterval = null;
    const leftCard = document.getElementById('footer-ad-left');
    const rightCard = document.getElementById('footer-ad-right');
    
    if (!leftCard || !rightCard) return { stop: () => {} };
    
    function renderAdvertisements() {
      const leftAd = footerAds[currentIndex % footerAds.length];
      const rightAd = footerAds[(currentIndex + 1) % footerAds.length];
      
      renderFooterCard(leftCard, leftAd);
      
      renderFooterCard(rightCard, rightAd);
      
      currentIndex = (currentIndex + 2) % footerAds.length;
    }
    
    function renderFooterCard(container, campaign) {
      if (!campaign || !container) return;
      
      const linkHtml = campaign.link ? 
        `<a href="${campaign.link}" target="_blank" class="advertisement-link" data-campaign_id="${campaign.id}"></a>` : '';
      
      const imageHtml = campaign.banner_pc_image ? 
        `<img src="${campaign.banner_pc_image}" class="img-fluid" style="width: 100%; height: 100%; object-fit: cover; object-position: center;" onload="this.style.opacity=1" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
         <div class="placeholder-banner" style="display: none; width: 100%; height: 100%; background-color: #e3f2fd; border: 2px solid #bbdefb; align-items: center; justify-content: center; color: #1976d2; font-weight: 500;">200x120px</div>` :
        `<div class="placeholder-banner" style="width: 100%; height: 100%; background-color: #e3f2fd; border: 2px solid #bbdefb; display: flex; align-items: center; justify-content: center; color: #1976d2; font-weight: 500;">200x120px</div>`;
      
      container.innerHTML = `
        <div class="ad-label">AD</div>
        <div class="advertisement-banner" style="position: relative; overflow: hidden;">
          ${imageHtml}
        </div>
        <div class="advertisement-description">${campaign.content || ''}</div>
        ${linkHtml}
      `;
      
      // Add click tracking for the link
      if (campaign.link) {
        const link = container.querySelector('.advertisement-link');
        if (link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            
            $.ajax({
              url: '/clicks',
              method: 'POST',
              data: {
                advertisement_campaign_id: campaign.id,
                _token: $('meta[name="csrf-token"]').attr('content')
              },
              success: function() {
                window.open(campaign.link, '_blank');
              },
              error: function() {
                window.open(campaign.link, '_blank');
              }
            });
          });
        }
      }
    }
    
    // Initial render with delay to ensure DOM is ready
    setTimeout(renderAdvertisements, 100);
    
    // Rotate every 3 seconds (increased from 2 seconds for better UX)
    rotationInterval = setInterval(renderAdvertisements, 3000);
    window.footerRotationInterval = rotationInterval; // Store globally for cleanup
    
    // Return cleanup function
    return {
      stop: () => {
        if (rotationInterval) {
          clearInterval(rotationInterval);
          rotationInterval = null;
        }
        if (window.footerRotationInterval) {
          clearInterval(window.footerRotationInterval);
          window.footerRotationInterval = null;
        }
      }
    };
  }

  // ===== UNIVERSAL MOBILE ADVERTISEMENTS ROTATION =====
  function initializeMobileAdvertisements(selector = '.mobile-advertisements') {
    // Clear any existing mobile rotation intervals
    if (window.mobileRotationIntervals) {
      window.mobileRotationIntervals.forEach(interval => clearInterval(interval));
      window.mobileRotationIntervals = [];
    } else {
      window.mobileRotationIntervals = [];
    }
    
    const containers = $(selector);
    const rotationInstances = [];
    
    containers.each(function() {
      const container = $(this);
      const position = container.data('position') || 'unknown';
      const mobileAds = container.find('.mobile-ad-item');
      
      if (mobileAds.length <= 1) return;
      
      // Restore currentIndex from data attribute if exists, otherwise start from 0
      let currentIndex = parseInt(container.data('current-ad-index')) || 0;
      if (currentIndex >= mobileAds.length) {
        currentIndex = 0;
      }
      let rotationInterval = null;
      
      function showNextAd() {
        mobileAds.removeClass('active');
        currentIndex = (currentIndex + 1) % mobileAds.length;
        $(mobileAds[currentIndex]).addClass('active');
        container.data('current-ad-index', currentIndex);
      }
      
      function startRotation() {
        stopRotation(); // Always stop first to prevent duplicates
        rotationInterval = setInterval(showNextAd, 3000); // 3 seconds
        window.mobileRotationIntervals.push(rotationInterval); // Track globally
      }
      
      function stopRotation() {
        if (rotationInterval) {
          clearInterval(rotationInterval);
          rotationInterval = null;
        }
      }
      
      mobileAds.removeClass('active');
      $(mobileAds[currentIndex]).addClass('active');
      
      // Start auto-rotation
      startRotation();
      
      // Pause on hover (for mobile touch devices, this won't trigger)
      container.on('mouseenter', stopRotation);
      container.on('mouseleave', startRotation);
      
      // Track clicks for mobile ads
      container.find('.mobile-ad-link').on('click', function(e) {
        const campaignId = $(this).data('campaign_id');
        const url = $(this).attr('href');
        
        if (campaignId && url) {
          e.preventDefault();
          
          $.ajax({
            url: '/clicks',
            method: 'POST',
            data: {
              advertisement_campaign_id: campaignId,
              _token: $('meta[name="csrf-token"]').attr('content')
            },
            success: function() {
              window.open(url, '_blank');
            },
            error: function() {
              window.open(url, '_blank');
            }
          });
        }
      });
      
      rotationInstances.push({
        position: position,
        stop: stopRotation
      });
    });
    
    return {
      instances: rotationInstances,
      stopAll: function() {
        rotationInstances.forEach(instance => instance.stop());
      }
    };
  }

  // ===== INITIALIZE ALL ADVERTISEMENT SYSTEMS =====
  function initializeAdvertisementCarousels() {
    initializeBootstrapCarousel();
    
    if ($('.mobile-advertisements').length > 0) {
      const mobileAds = initializeMobileAdvertisements();
      window.stopMobileAdvertisements = mobileAds.stopAll;
    }
    
    if ($('#footer-ad-left, #footer-ad-right').length > 0) {
      const footerAds = initializeFooterAdvertisements();
      window.stopFooterAdvertisements = footerAds.stop;
    }
  }

  // ===== DELETE MODAL =====
  $(document).on('click', '.modal-admin-destroy-advertisement', function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    
    if (!id) {
      console.error('No ID found for deletion');
      return;
    }
    
    $.ajax({
      url: '/user/advertisement_campaigns/' + id,
      type: 'DELETE',
      data: {
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        if (response.success) {
          console.log('response.success', response.success);
          console.log('id', id);
          const deleteModal = document.getElementById('staticBackdrop-' + id);
          
          if (deleteModal) {
            deleteModal.classList.remove('show');
            deleteModal.style.display = 'none';
            deleteModal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('modal-open');
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) backdrop.remove();
          }
        }
        window.location.href = window.location.pathname + '?tab=hidden';
      },    
      error: function(xhr) {
        console.error('Error deleting advertisement campaign:', xhr);
        window.location.href = window.location.pathname + '?tab=hidden';
      }
    });
  });

  $(document).on('click', '[data-bs-target="#deleteModal"]', function(e) {});

  // ===== CONTRACT DOWNLOAD =====
  $(document).on('click', '#downloadContractBtn', function(e) {
    e.preventDefault();
    
    const button = $(this);
    const campaignId = window.location.pathname.split('/').pop();
    
    setButtonLoading(button, true);
    
    downloadContract(campaignId, button);
  });

  function setButtonLoading(button, isLoading) {
    const btnText = button.find('.btn-text');
    const spinner = button.find('.spinner-border');
    
    const otherButtons = $('.advertisement-confirm-buttons .btn').not(button);
    
    if (isLoading) {
      btnText.text('ダウンロード中...');
      spinner.removeClass('d-none');
      button.prop('disabled', true);
      
      otherButtons.prop('disabled', true).addClass('disabled');
    } else {
      btnText.text('契約書をダウンロード');
      spinner.addClass('d-none');
      button.prop('disabled', false);
      
      otherButtons.prop('disabled', false).removeClass('disabled');
    }
  }

  function downloadContract(campaignId, button) {
    const url = `/user/advertisement_campaigns/${campaignId}/download_contract`;
    
    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/pdf'
      }
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }).catch(() => {
          throw new Error(`HTTP error! status: ${response.status}`);
        });
      }
      
      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'contract.pdf';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      return response.blob().then(blob => ({ blob, filename }));
    })
    .then(({ blob, filename }) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      setButtonLoading(button, false);
    })
    .catch(error => {
      console.error('Error downloading contract:', error);
      alert(error.message || '契約書のダウンロードに失敗しました。');
      
      setButtonLoading(button, false);
    });
  }

  // ===== EVENT LISTENERS =====
  $(document).on('change', 'input[name="advertisement_campaign[placement_position][]"]', function() {
    updatePricingSummary();
  });

  $(document).on('change', '#duration_months', function() {
    updatePricingSummary();
  });

  // ===== INITIALIZATION =====
  preserveCitySelect();
  initializeBannerPreview();
  initializePricing();
  initializeCardClicks();
  initializeAdvertisementPreview();
  initializeAdvertisementCarousels();
  initializeRenewalHandlers();
  initPositionPreview();
  
  // ===== TURBO/TURBOLINKS SUPPORT =====
  function reinitializeOnPageLoad() {
    initPositionPreview();
    if (window.stopFooterAdvertisements) {
      window.stopFooterAdvertisements();
    }
    if (window.stopMobileAdvertisements) {
      window.stopMobileAdvertisements();
    }
    if (window.stopAdvertisementTopMiddleAutoScroll) {
      window.stopAdvertisementTopMiddleAutoScroll();
    }
    if (window.stopAdvertisementFooterAutoScroll) {
      window.stopAdvertisementFooterAutoScroll();
    }
    if (window.stopAdvertisementHeaderAutoScroll) {
      window.stopAdvertisementHeaderAutoScroll();
    }
    
    Object.keys(window).forEach(key => {
      if (key.includes('scrollAdvertisements_') && key.includes('_interval')) {
        if (window[key]) {
          clearInterval(window[key]);
          window[key] = null;
        }
      }
    });
    
    if (window.footerRotationInterval) {
      clearInterval(window.footerRotationInterval);
      window.footerRotationInterval = null;
    }
    
    if (window.mobileRotationIntervals) {
      window.mobileRotationIntervals.forEach(interval => clearInterval(interval));
      window.mobileRotationIntervals = [];
    }
    
    currentRenewalCampaignId = null;
    
    setTimeout(() => {
      preserveCitySelect();
      initializeBannerPreview();
      initializePricing();
      initializeCardClicks();
      initializeAdvertisementPreview();
      initializeAdvertisementCarousels();
      initializeRenewalHandlers();
    }, 200);
  }

  $(document).on('turbo:load turbolinks:load', reinitializeOnPageLoad);
  
  let resizeTimeout;
  $(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initializeAdvertisementCarousels();
    }, 250);
  });
  $(document).on('DOMContentLoaded', reinitializeOnPageLoad);

  // ===== FORM SUBMIT LOADING =====
  $('body').on('submit', 'form[data-turbo="false"][action*="advertisement_campaigns"]', function(e) {
    const $form = $(this);
    const $submitBtn = $form.find('#confirmCreateBtn');
    const $cancelBtn = $('#cancelCreateBtn');
    
    if ($submitBtn.length && $cancelBtn.length) {
      $submitBtn.prop('disabled', true);
      $submitBtn.val('処理中...');
      
      $cancelBtn.prop('disabled', true);
      
      $form.addClass('form-loading');
    }
  });

  // ===== RENEWAL HANDLERS =====
  let currentRenewalCampaignId = null;
  
  function initializeRenewalHandlers() {
    $('body').off('click', '.btn-advertisement-renewal #confirmRenewalBtn');
    $('#renewalModal').off('show.bs.modal hidden.bs.modal');
    
    $('body').on('click', '.btn-advertisement-renewal', function(e) {
      e.preventDefault();
      currentRenewalCampaignId = $(this).data('campaign-id');
      
      if (!currentRenewalCampaignId) {
        alert('エラー: キャンペーンIDが見つかりません。');
        return;
      }
    });
    
    $('body').on('click', '#confirmRenewalBtn', function(e) {
      e.preventDefault();
      
      if (!currentRenewalCampaignId) {
        alert('エラー: キャンペーンIDが見つかりません。ページを再読み込みしてください。');
        return;
      }
      
      const $button = $(this);
      const $cancelBtn = $('#cancelRenewalBtn');
      
      setRenewalButtonLoading($button, true);
      $cancelBtn.prop('disabled', true);
      
      $.ajax({
        url: `/user/advertisement_campaigns/${currentRenewalCampaignId}/request_renewal`,
        method: 'POST',
        dataType: 'json',
        success: function(data) {
          if (data.success) {
            $('#renewalModal').hide();
            window.location.reload();
          }
        },
        error: function() {
          alert('更新リクエストの送信に失敗しました。ページを再読み込みして再試行してください。');
          $('#renewalModal').modal('hide');
          setTimeout(() => window.location.reload(), 1000);
        }
      });
    });
    
    $('#renewalModal').on('hidden.bs.modal', function() {
      currentRenewalCampaignId = null;
      const $button = $('#confirmRenewalBtn');
      const $cancelBtn = $('#cancelRenewalBtn');
      setRenewalButtonLoading($button, false);
      $cancelBtn.prop('disabled', false);
    });
  }
  
  // ===== RENEWAL BUTTON LOADING HELPER =====
  function setRenewalButtonLoading($btn, isLoading) {
    const $btnText = $btn.find('.btn-text');
    const $spinner = $btn.find('.spinner-border');
    
    $btn.prop('disabled', isLoading);
    $btnText.text(isLoading ? '処理中...' : '契約を継続する');
    $spinner.toggleClass('d-none', !isLoading);
    
    if (isLoading) {
      $btn.addClass('btn-loading');
    } else {
      $btn.removeClass('btn-loading');
    }
  }

  // ===== POSITION PREVIEW HANDLER =====
  function initPositionPreview() {
    const $modal = $('#positionPreviewModal');
    const modalElement = $modal[0];
    
    if (!modalElement) return;
    
    function restoreBodyScroll() {
      const body = document.body;
      $('.modal-backdrop').remove();
      $(body).removeClass('modal-open overflow-hidden');
      
      if (body.style) {
        body.style.removeProperty('overflow');
        body.style.removeProperty('padding-right');
        body.style.removeProperty('padding-left');
      }
      $(body).css({ overflow: '', 'padding-right': '', 'padding-left': '' });
    }
    
    modalElement.addEventListener('hidden.bs.modal', function() {
      restoreBodyScroll();
    });
    
    $(document).off('click', '.preview-icon').on('click', '.preview-icon', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const imagePath = $(this).data('image');
      if (!imagePath) return;
      
      $modal.find('.position-preview-image').attr('src', imagePath);
      
      let modal = bootstrap.Modal.getInstance(modalElement);
      if (!modal) {
        modal = new bootstrap.Modal(modalElement);
      }
      modal.show();
    });
  }
});
